import _ from 'lodash'
import enums from 'scoreboard/components/enums'

export default {
	fontSize: [
		{id: 'extra-large', label: 'common.extraLarge'},
		{id: 'large', label: 'common.large'},
		{id: 'medium', label: 'common.medium'},
		{id: 'small', label: 'common.small'}
	],
	colorType: function(
		removeScoringColor, removeConditionalColor, removeOverallColor
	)  {
		let opts = _.keyBy(
			enums.toOptionData('colorType'),
			'id'
		)
		//certain columns do not allow scoring color as an option
		//https://github.com/SpiderStrategies/Scoreboard/issues/20257
		if (removeScoringColor) {
			opts = _.omit(opts, 'scoring')
		}

		if (removeConditionalColor) {
			opts = _.omit(opts, 'conditional')
		}

		if (removeOverallColor) {
			opts = _.omit(opts, 'overall')
		}

		return opts
	},
	colorStyle: () => {
		const options = enums
			.toOptionData('colorStyle', ['generic', 'text', 'perspective'])
		return _.sortBy(options, ({ id }) => ['triangle', 'fill', 'text']
			.indexOf(id))
	}
}